import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsentCheckGuard, ErrorPageComponent } from '@hohr/components';
import { AccessGuard } from './shared/guards/access.guard';
import { CustomAuthenticationGuard } from './shared/guards/custom-authentication.guard';
import { CanCreateCVGuard } from './shared/guards/custom-can-create-cv.guard';

const routes: Routes = [
  { path: 'error', component: ErrorPageComponent },
  {
    path: 'consent',
    loadChildren: () => import('@hohr/components').then((m) => m.ConsentModule),
    canActivate: [CustomAuthenticationGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/login/login.module').then((m) => m.LoginModule),
    canActivate: [AccessGuard],
  },
  {
    path: 'create',
    loadChildren: () =>
      import('./features/create-cv/create-cv.module').then(
        (m) => m.CreateCvModule
      ),
    canActivate: [
      CustomAuthenticationGuard,
      ConsentCheckGuard,
      CanCreateCVGuard,
    ],
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/homepage/homepage.module').then(
        (m) => m.HomepageModule
      ),
    canActivate: [AccessGuard],
  },
  {
    path: 'my-cvs',
    loadChildren: () =>
      import('./features/my-cvs/my-cvs.module').then((m) => m.MyCvsModule),
    canActivate: [CustomAuthenticationGuard, ConsentCheckGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
